import React, { useState, useEffect } from "react";
import "./riskhistory.css";
import { baseRequest } from "../../../axiosconfig";

// Osoba koja je napravila izmenu: ime i prezime zaposlenog, inače imejl
// (isto pravilo kao Evidencija aktivnosti); za deaktiviran nalog originalni imejl
const userDisplayName = (user) => {
  const emp = user?.employee;
  const name = `${emp?.first_name || ""} ${emp?.last_name || ""}`.trim();
  return name || user?.original_email || user?.email || "—";
};

const riskColors = {
  nizak: "#B0E0E6",
  srednji: "#FFD700",
  visok: "#FF5C5C",
};

function trendIndicator(history) {
  if (history.length < 2) return null;
  const prev = history[history.length - 2].total;
  const last = history[history.length - 1].total;
  if (last > prev) return { text: "↑ Rizik povećan u odnosu na prethodnu procenu", color: "#FF5C5C" };
  if (last < prev) return { text: "↓ Rizik smanjen u odnosu na prethodnu procenu", color: "#2E8B57" };
  return { text: "Rizik bez promene u odnosu na prethodnu procenu", color: "var(--mainColor)" };
}

function RiskHistory({ riskFormId, refreshKey }) {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (!riskFormId) return;
    baseRequest
      .get(`/risk_history/${riskFormId}`)
      .then((res) => setHistory(res.data.risk_history || []))
      .catch(() => setHistory([]));
  }, [riskFormId, refreshKey]);

  if (!history.length) return null;

  const trend = trendIndicator(history);
  const formatDateTime = (d) =>
    `${new Date(d).toLocaleDateString("sr-RS")} ${new Date(d).toLocaleTimeString("sr-RS", { hour: "2-digit", minute: "2-digit" })}`;

  return (
    <div className="risk-history">
      <h3 className="risk-history-title">ISTORIJA PROCENE RIZIKA</h3>
      {trend && (
        <p className="risk-history-trend" style={{ color: trend.color }}>
          {trend.text}
        </p>
      )}
      <table className="risk-history-table">
        <thead>
          <tr>
            <th>DATUM PROCENE</th>
            <th>PROCENIO</th>
            <th>VEROVATNOĆA</th>
            <th>UTICAJ</th>
            <th>UKUPNO</th>
            <th>NIVO RIZIKA</th>
            <th>PREOSTALI RIZIK</th>
          </tr>
        </thead>
        <tbody>
          {history.map((h) => (
            <tr key={h.id}>
              <td>{formatDateTime(h.created_at)}</td>
              <td>{userDisplayName(h.user)}</td>
              <td>{h.probability}</td>
              <td>{h.influence}</td>
              <td>
                {h.total} ({h.percentage}%)
              </td>
              <td style={{ backgroundColor: riskColors[h.risk_level], color: "#000" }}>
                {h.risk_level}
              </td>
              <td>
                {h.residual_percentage !== null && h.residual_percentage !== undefined
                  ? `${h.residual_percentage}%`
                  : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default RiskHistory;
